/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const CalculatorLarge = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 21 30" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M19 2.005H2v25.98h17zm0-2.038c1.104 0 2 .898 2 2.006v25.981a2.003 2.003 0 0 1-2 2.006H2c-1.105 0-2-.898-2-2.006V1.974C0 .865.895-.033 2-.033zm-2.001 4.04L17 11H4l.001-6.994zm-9.971 11.98H4.003V13h3.025zm0 4.998H4.003v-2.984h3.025zm0 5H4.003V23h3.025zm5-9.999H9.003v-2.985h3.024zm0 4.999H9.003v-2.984h3.024zm0 5H9.003V23h3.024zm4.968-9.999h-2.993v-2.985h2.993zm0 9.996h-2.993v-7.981h2.993z" />
      </g>
    </svg>
  </span>
);

CalculatorLarge.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

CalculatorLarge.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default CalculatorLarge;
